<template>
  <div class="regist">
    <Alert
      v-if="visibleErrorMessage"
      text="入力内容に問題があります。確認して再度お試しください。"
    />
    <Alert
      v-if="formLineMessage"
      text='会員登録はまだ完了していません。<br class="hiddenPc">必要事項を入力の上、確認画面にお進みください。'
    />
    <section>
      <HeadingLv3
        text="会員情報を登録してください。"
        setLabelSlot
        class="profile-head"
      >
      </HeadingLv3>
      <div class="profile-note">
        ＊
        直接必要な情報をすべて入力いただけていない場合は、マイナビRESIDENTのすべてのサービスを利用できないことがあります。
      </div>
      <section>
        <FormInputField
          label="姓"
          patternLabel="全角"
          placeholder="例：山田"
          name="name_sei"
          :value="data.userProfile.name_sei"
          :error="validations.name_sei.isError"
          :error-message="validations.name_sei.errorMessage"
          @change-message="changeMessage('name_sei', $event)"
          req
        />
        <FormInputField
          label="名"
          patternLabel="全角"
          placeholder="例：太郎"
          name="name_mei"
          :value="data.userProfile.name_mei"
          :error="validations.name_mei.isError"
          :error-message="validations.name_mei.errorMessage"
          @change-message="changeMessage('name_mei', $event)"
          req
        />
        <FormInputField
          label="セイ"
          patternLabel="全角"
          placeholder="例：ヤマダ"
          name="kana_sei"
          :value="data.userProfile.kana_sei"
          :error="validations.kana_sei.isError"
          :error-message="validations.kana_sei.errorMessage"
          @change-message="changeMessage('kana_sei', $event)"
          req
        />
        <FormInputField
          label="メイ"
          patternLabel="全角"
          placeholder="例：タロウ"
          name="kana_mei"
          :value="data.userProfile.kana_mei"
          :error="validations.kana_mei.isError"
          :error-message="validations.kana_mei.errorMessage"
          @change-message="changeMessage('kana_mei', $event)"
          req
        />
        <FormRadioField
          label="性別"
          name="gender"
          :current-value="data.userProfile.gender"
          :error="validations.gender.isError"
          :error-message="validations.gender.errorMessage"
          :items="genders"
          @change-value="changeMessage('gender', $event)"
          req
        />
        <FormBirthDate
          name="birthday"
          label="生年月日"
          :value="data.userProfile.birthday"
          :error="validations.birthday.isError"
          :error-message="validations.birthday.errorMessage"
          :fullYear="data.userProfile.birthday"
          @selection-change="changeMessage('birthday', $event)"
          req
        />
        <FormInputField
          name="email"
          label="メールアドレス"
          patternLabel="半角英数"
          placeholder="例：abd@example.com"
          :value="data.userProfile.email"
          :error="validations.email.isError"
          :error-message="validations.email.errorMessage"
          @change-message="changeMessage('email', $event)"
          req
        />
        <FormInputField
          name="email_confirmation"
          label="メールアドレス(確認用)"
          patternLabel="半角英数"
          placeholder="例：abd@example.com"
          :value="data.userProfile.email_confirmation"
          :error="validations.email_confirmation.isError"
          :error-message="validations.email_confirmation.errorMessage"
          @change-message="
            checkConfirmField(
              { name: 'email_confirmation', target: data.userProfile.email },
              $event
            )
          "
          req
        />

        <FormGroup label="住所" optional>
          <FormInputField
            name="zip"
            label="郵便番号"
            patternLabel="半角"
            placeholder="郵便番号7桁を入力（ハイフン無し）"
            description="＊郵便番号を入力すると住所が自動検索されます。"
            :value="data.userProfile.zip"
            :error="validations.zip.isError"
            :error-message="validations.zip.errorMessage"
            @change-message="inputZip('zip', $event)"
            size="lg"
          />
          <FormSelectField
            id="prefecture"
            name="prefecture"
            label="都道府県"
            :value="data.userProfile.prefecture"
            :error="validations.prefecture.isError"
            :error-message="validations.prefecture.errorMessage"
            :items="prefectures"
            @change-message="changeMessage('prefecture', $event)"
          />
          <FormInputField
            id="city"
            label="市区町村"
            name="municipalities"
            patternLabel="全角"
            placeholder="例：千代田区"
            :value="data.userProfile.city"
            :error="validations.city.isError"
            :error-message="validations.city.errorMessage"
            @change-message="changeMessage('city', $event)"
          />
          <FormInputField
            id="town"
            name="municipalitiesNameNumber"
            label="町名番地、建物等"
            placeholder="例：神田佐久間町1-33-3 〇〇マンション101号室"
            :value="data.userProfile.town"
            :error="validations.town.isError"
            :error-message="validations.town.errorMessage"
            @change-message="changeMessage('town', $event)"
          />
        </FormGroup>

        <FormInputField
          id="tel"
          label="電話番号"
          placeholder="0000000000"
          name="telPhoneNumber"
          :value="data.userProfile.tel"
          :error="validations.tel.isError"
          :error-message="validations.tel.errorMessage"
          @change-message="changeMessage('tel', $event)"
          optional
        />

        <FormFieldset label="休暇中住所" optional>
          <CheckboxButtons
            name="diff_address"
            :items="[
              {
                label: '上記の住所と同じ',
                value: '1',
                id: 'diff_address',
                checked: data.userProfile.isEqualHolidayAddress,
                error: false
              }
            ]"
            style="white-space: nowrap"
            @change-checkbox="changeVacationAddressState"
          />
        </FormFieldset>

        <FormGroup>
          <FormInputField
            id="zip_vacation"
            label="郵便番号"
            patternLabel="半角"
            placeholder="郵便番号7桁を入力（ハイフン無し）"
            description="＊郵便番号を入力すると住所が自動検索されます。"
            :value="data.userProfile.zip_vacation"
            :error="validations.zip_vacation.isError"
            :error-message="validations.zip_vacation.errorMessage"
            :disabled="data.userProfile.isEqualHolidayAddress"
            @change-message="inputZip('zip_vacation', $event)"
            size="lg"
          />
          <FormSelectField
            id="prefecture_vacation"
            name="prefecture"
            label="都道府県"
            :value="data.userProfile.prefecture_vacation"
            :error="validations.prefecture_vacation.isError"
            :error-message="validations.prefecture_vacation.errorMessage"
            :items="prefectures_vacation"
            :disabled="data.userProfile.isEqualHolidayAddress"
            @change-message="changeMessage('prefecture_vacation', $event)"
          />
          <FormInputField
            id="city_vacation"
            label="市区町村"
            patternLabel="全角"
            placeholder="例：千代田区"
            :value="data.userProfile.city_vacation"
            :error="validations.city_vacation.isError"
            :error-message="validations.city_vacation.errorMessage"
            :disabled="data.userProfile.isEqualHolidayAddress"
            @change-message="changeMessage('city_vacation', $event)"
          />
          <FormInputField
            id="town_vacation"
            name="municipalitiesNameNumber"
            label="町名番地、建物等"
            placeholder="例：神田佐久間町1-33-3 〇〇マンション101号室"
            :value="data.userProfile.town_vacation"
            :error="validations.town_vacation.isError"
            :error-message="validations.town_vacation.errorMessage"
            :disabled="data.userProfile.isEqualHolidayAddress"
            @change-message="changeMessage('town_vacation', $event)"
          />
        </FormGroup>

        <FormSelectField
          name="school_id"
          label="大学名"
          :items="universities"
          :error="validations.school_id.isError"
          :error-message="validations.school_id.errorMessage"
          :value="data.userProfile.school_id"
          @change-message="changeMessage('school_id', $event)"
          req
        />

        <FormSelectField
          name="graduate_year"
          label="卒業時期（年）"
          :items="setYear('graduate')"
          :error="validations.graduate_year.isError"
          :error-message="validations.graduate_year.errorMessage"
          :value="data.userProfile.graduate_year"
          @change-message="changeMessage('graduate_year', $event)"
          req
        />

        <template v-if="data.memberType === '2'">
          <FormSelectField
            name="licensing_year"
            label="医師免許取得年"
            :items="setYear()"
            :error="validations.licensing_year.isError"
            :error-message="validations.licensing_year.errorMessage"
            :value="data.userProfile.licensing_year"
            @change-message="changeMessage('licensing_year', $event)"
            req
          />

          <FormInputField
            name="work_place"
            label="現勤務先"
            patternLabel="全角"
            placeholder="例：〇〇病院"
            :value="data.userProfile.work_place"
            :error="validations.work_place.isError"
            :error-message="validations.work_place.errorMessage"
            @change-message="changeMessage('work_place', $event)"
            req
          />

          <FormGroup
            label="希望科目"
            pattern-label="3つまでお選びください。"
            optional
          >
            <FormSelectField
              name="hoped_departments01"
              label="第1希望"
              :items="hoped_departments01"
              :error="validations.hoped_departments01.isError"
              :error-message="validations.hoped_departments01.errorMessage"
              @change-message="changeMessage('hoped_departments01', $event)"
            />

            <FormSelectField
              name="hoped_departments02"
              label="第2希望"
              :items="hoped_departments02"
              :error="validations.hoped_departments02.isError"
              :error-message="validations.hoped_departments02.errorMessage"
              @change-message="changeMessage('hoped_departments02', $event)"
            />

            <FormSelectField
              name="hoped_departments03"
              label="第3希望"
              :items="hoped_departments03"
              :error="validations.hoped_departments03.isError"
              :error-message="validations.hoped_departments03.errorMessage"
              @change-message="changeMessage('hoped_departments03', $event)"
            />
          </FormGroup>
        </template>

        <FormInputField
          v-show="data.userProfile.socialplus_id === ''"
          id="password"
          type="password"
          name="password"
          :password-switch="true"
          :value="data.userProfile.password"
          label="パスワード"
          patternLabel="半角英数"
          description="＊半角英数字記号8～30文字以内<br>＊半角英数字の組み合わせが必要"
          placeholder="パスワードを入力してください"
          :error="validations.password.isError"
          :error-message="validations.password.errorMessage"
          @change-message="changeMessage('password', $event)"
          req
        />

        <FormInputField
          v-show="data.userProfile.socialplus_id === ''"
          id="password_confirmation"
          type="password"
          name="password_confirmation"
          :password-switch="true"
          :value="data.userProfile.password_confirmation"
          label="パスワード(確認用) "
          patternLabel="半角英数"
          description="＊半角英数字記号8～30文字以内<br>＊半角英数字の組み合わせが必要"
          placeholder="パスワード(確認用)を入力してください"
          :error="validations.password_confirmation.isError"
          :error-message="validations.password_confirmation.errorMessage"
          @change-message="
            checkConfirmField(
              {
                name: 'password_confirmation',
                target: data.userProfile.password
              },
              $event
            )
          "
          req
        />

        <input
          id="socialplus_id"
          type="hidden"
          name="socialplus_id"
          :value="data.userProfile.socialplus_id"
          @change-message="changeMessage('socialplus_id', $event)"
        />
      </section>
    </section>

    <GoalButtons>
      <Button label="戻る" :handleClick="goBack" />
      <Button
        label="入力内容を確認"
        :handleClick="confirm"
        :disabled="isDisabledNextBtn"
        primary
      />
    </GoalButtons>
  </div>
</template>

<script lang="ts">
import axios from 'axios'
import {
  defineComponent,
  onMounted,
  computed,
  SetupContext,
  reactive,
  ref
} from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import smoothscroll from 'smoothscroll-polyfill'
import { applyValidation } from '@/utils/validation'
import FormFieldset from '@/components/block/FormFieldset.vue'
import FormGroup from '@/components/block/FormGroup.vue'
import FormInputField from '@/components/block/FormInputField.vue'
import FormRadioField from '@/components/block/FormRadioField.vue'
import FormSelectField from '@/components/block/FormSelectField.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import CheckboxButtons from '@/components/block/FormCheckboxButtons.vue'
import FormBirthDate from '@/components/block/FormBirthDate.vue'
import Alert from '@/components/elements/Alert.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'RegistProfile',

  components: {
    FormFieldset,
    FormGroup,
    FormInputField,
    FormRadioField,
    FormSelectField,
    GoalButtons,
    CheckboxButtons,
    FormBirthDate,
    Alert,
    HeadingLv3,
    Button
  },

  props: {
    data: Object,
    state: {
      type: Object,
      require: true
    }
  },

  setup(props: any, context: SetupContext) {
    const store = useStore()
    const router = useRouter()

    // 入力ページ経由じゃない場合は弾く
    // if (!props.state.isLandingInput) {
    //   router.replace('/500')
    // }

    const visibleErrorMessage = ref<boolean>(false)
    const formLineMessage = ref<boolean>(false)

    // ------------------------------------------------------
    // データ取得・セット
    // ------------------------------------------------------
    interface RadioObject {
      label: string
      value: string
      id: string
    }
    interface SelectObject {
      label: string
      value: string
      selected: boolean
    }
    const selectDefault = {
      label: '選択してください',
      value: '',
      selected: false
    }

    // 性別をセット
    const genders: Array<RadioObject> = reactive([])
    store.state.master.gender.forEach((el: any) => {
      if (el.opt_id === '0') return

      const item: RadioObject = {
        label: el.option_name,
        value: el.opt_id,
        id: 'gender' + el.opt_id
      }
      genders.push(item)
    })

    // 都道府県をセット
    const prefectures: Array<SelectObject> = reactive([selectDefault])
    const prefectures_vacation: Array<SelectObject> = reactive([selectDefault])
    const selectedPref = props.data.userProfile.prefecture
      ? props.data.userProfile.prefecture
      : 0
    const selectedPrefVacation = props.data.userProfile.prefecture_vacation
      ? props.data.userProfile.prefecture_vacation
      : 0

    store.state.master.prefectures.forEach((el: any) => {
      if (el.opt_id === '0') return

      const item: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedPref === el.opt_id ? true : false
      }
      const item2: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedPrefVacation === el.opt_id ? true : false
      }
      prefectures.push(item)
      prefectures_vacation.push(item2)
    })

    // 大学をセット
    const universities: Array<SelectObject> = reactive([selectDefault])
    const selectedSchool = props.data.userProfile.school_id
      ? props.data.userProfile.school_id
      : 0

    store.state.master.university.forEach((el: any) => {
      if (el.opt_id === '0') return

      const item: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedSchool === el.opt_id ? true : false
      }
      universities.push(item)
    })

    // 希望科目をセット
    const hoped_departments01: Array<SelectObject> = reactive([selectDefault])
    const hoped_departments02: Array<SelectObject> = reactive([selectDefault])
    const hoped_departments03: Array<SelectObject> = reactive([selectDefault])
    const selectedHd01 = props.data.userProfile.hoped_departments[0]
      ? props.data.userProfile.hoped_departments[0]
      : 0
    const selectedHd02 = props.data.userProfile.hoped_departments[1]
      ? props.data.userProfile.hoped_departments[1]
      : 0
    const selectedHd03 = props.data.userProfile.hoped_departments[2]
      ? props.data.userProfile.hoped_departments[2]
      : 0

    store.state.master.departments.forEach((el: any) => {
      if (el.opt_id === '0') return

      const item01: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedHd01 === el.opt_id ? true : false
      }
      const item02: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedHd02 === el.opt_id ? true : false
      }
      const item03: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedHd03 === el.opt_id ? true : false
      }
      hoped_departments01.push(item01)
      hoped_departments02.push(item02)
      hoped_departments03.push(item03)
    })

    // 年をセット
    const setYear = (type: string) => {
      const years: Array<SelectObject> = []
      const endSettingValue = type === 'graduate' ? 7 : 0
      const thisYear = new Date().getFullYear()
      const startYear = thisYear - 20
      const endYear = thisYear + endSettingValue

      let selectedYear = 0
      years.push({
        label: '選択してください',
        value: '',
        selected: false
      })
      if (type === 'graduate') {
        selectedYear = props.data.userProfile.graduate_year
          ? Number(props.data.userProfile.graduate_year)
          : 0
      } else {
        selectedYear = props.data.userProfile.licensing_year
          ? Number(props.data.userProfile.licensing_year)
          : 0
      }

      for (let i = endYear; i >= startYear; i--) {
        years.push({
          label: i + '年',
          value: i + '',
          selected: i === selectedYear ? true : false
        })
      }

      return years
    }

    let isBirthDayInputCompleteOnce = false

    if (props.data.userProfile.birthday) {
      const arr = props.data.userProfile.birthday.split('/')
      if (arr[0] && arr[1] && arr[2]) isBirthDayInputCompleteOnce = true
    }

    // ------------------------------------------------------
    // バリデーション設定
    // ------------------------------------------------------
    interface ValidationsObject {
      [key: string]: any
    }

    const validations: ValidationsObject = reactive({
      name_sei: {
        rules: ['required', 'max:500'],
        isError: false,
        errorMessage: ''
      },
      name_mei: {
        rules: ['required', 'max:500'],
        isError: false,
        errorMessage: ''
      },
      kana_sei: {
        rules: ['required', 'max:500', 'kana'],
        isError: false,
        errorMessage: ''
      },
      kana_mei: {
        rules: ['required', 'max:500', 'kana'],
        isError: false,
        errorMessage: ''
      },
      birthday: {
        rules: ['required', 'date'],
        isError: false,
        errorMessage: ''
      },
      gender: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      email: {
        rules: ['required', 'max:500', 'email'],
        isError: false,
        errorMessage: ''
      },
      email_confirmation: {
        rules: ['required', 'matchEmail'],
        isError: false,
        errorMessage: ''
      },
      zip: {
        rules: ['zip'],
        isError: false,
        errorMessage: ''
      },
      prefecture: {
        rules: ['select'],
        isError: false,
        errorMessage: ''
      },
      city: {
        rules: ['max:255'],
        isError: false,
        errorMessage: ''
      },
      town: {
        rules: ['max:255'],
        isError: false,
        errorMessage: ''
      },
      tel: {
        rules: ['max:500', 'hankakueisu'],
        isError: false,
        errorMessage: ''
      },
      zip_vacation: {
        rules: ['zip'],
        isError: false,
        errorMessage: ''
      },
      prefecture_vacation: {
        rules: ['select'],
        isError: false,
        errorMessage: ''
      },
      city_vacation: {
        rules: ['max:255'],
        isError: false,
        errorMessage: ''
      },
      town_vacation: {
        rules: ['max:255'],
        isError: false,
        errorMessage: ''
      },
      school_id: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      graduate_year: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      licensing_year: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      work_place: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      },
      hoped_departments01: {
        rules: ['select'],
        isError: false,
        errorMessage: ''
      },
      hoped_departments02: {
        rules: ['select'],
        isError: false,
        errorMessage: ''
      },
      hoped_departments03: {
        rules: ['select'],
        isError: false,
        errorMessage: ''
      },
      password: {
        rules: ['password'],
        isError: false,
        errorMessage: ''
      },
      password_confirmation: {
        rules: ['matchPassword'],
        isError: false,
        errorMessage: ''
      },
      socialplus_id: {
        rules: ['max:255'],
        isError: false,
        errorMessage: ''
      }
    })

    // ------------------------------------------------------
    // 値の入力・アップデート
    // ------------------------------------------------------

    // Eメール確認用
    const checkConfirmField = (obj: Record<string, string>, value: string) => {
      const rules = validations[obj.name].rules

      const arr: Array<string> = []

      for (let i = 0; i < rules.length; i++) {
        if (rules[i] === 'matchEmail') {
          arr.push('matchEmail:' + obj.target)
        } else if (
          rules[i] === 'matchPassword' &&
          props.data.userProfile.socialplus_id === ''
        ) {
          arr.push('matchPassword:' + obj.target)
        } else {
          arr.push(rules[i])
        }
      }

      const result = applyValidation(arr, value)

      validations[obj.name].isError = result.isError
      validations[obj.name].errorMessage = result.message

      context.emit('update-profile', obj.name, value)
    }

    const changeMessage = (name: string, value: string) => {
      context.emit('update-profile', name, value)

      if (name === 'birthday' && value) {
        const arr = value.split('/')
        // 入力値がどこか空だったら
        if (!arr[0] || !arr[1] || !arr[2]) {
          if (isBirthDayInputCompleteOnce) {
            value = '' // 一度全て入力している場合は必須エラーになるように
          } else {
            return // 一度も入力完了していない場合はエラーにしない
          }
        }
        // 全て入力完了したらフラグをtrueに
        if (arr[0] && arr[1] && arr[2]) {
          isBirthDayInputCompleteOnce = true
        }
      }

      const result = applyValidation(validations[name].rules, value)
      console.log('validations', validations)

      validations[name].isError = result.isError
      validations[name].errorMessage = result.message

      if (
        name === 'email' &&
        props.data.userProfile.email_confirmation &&
        props.data.userProfile.socialplus_id === ''
      ) {
        checkConfirmField(
          { name: 'email_confirmation', target: props.data.userProfile.email },
          props.data.userProfile.email_confirmation
        )
      }
      if (
        name === 'password' &&
        props.data.userProfile.password_confirmation &&
        props.data.userProfile.socialplus_id === ''
      ) {
        checkConfirmField(
          {
            name: 'password_confirmation',
            target: props.data.userProfile.password
          },
          props.data.userProfile.password_confirmation
        )
      }
    }

    // 郵便番号から住所取得
    const getAddressFromZipCode = (name: string, value: string) => {
      const zip1 = value.substr(0, 3)
      const zip2 = value.substr(3, 4)

      axios
        .get(
          `https://madefor.github.io/postal-code-api/api/v1/${zip1}/${zip2}.json`
        )
        .then((res) => {
          let selectedPref = 0

          for (let i = 0; i < prefectures.length; i++) {
            if (
              Number(res.data.data[0].prefcode) === Number(prefectures[i].value)
            ) {
              selectedPref = i
            }
          }

          if (name === 'zip') {
            prefectures[selectedPref].selected = true
            changeMessage('prefecture', prefectures[selectedPref].value)
            changeMessage('city', res.data.data[0].ja.address1)
            changeMessage('town', res.data.data[0].ja.address2)
          }
          if (name === 'zip_vacation') {
            prefectures_vacation[selectedPref].selected = true
            changeMessage(
              'prefecture_vacation',
              prefectures_vacation[selectedPref].value
            )
            changeMessage('city_vacation', res.data.data[0].ja.address1)
            changeMessage('town_vacation', res.data.data[0].ja.address2)
          }
        })
    }

    const inputZip = (name: string, value: string) => {
      changeMessage(name, value)

      if (/^[0-9]{7}$/.test(value)) {
        getAddressFromZipCode(name, value)
      }
    }

    const changeVacationAddressState = (ev: Record<string, boolean>) => {
      context.emit('update-profile', 'isEqualHolidayAddress', ev.checked)
    }

    // ------------------------------------------------------
    // 確認ボタンの実装と制御
    // ------------------------------------------------------

    // 確認ボタンの活性・非活性制御
    const isDisabledNextBtn = computed(() => {
      if (
        props.data.userProfile.name_sei === '' ||
        props.data.userProfile.name_mei === '' ||
        props.data.userProfile.kana_sei === '' ||
        props.data.userProfile.kana_mei === '' ||
        props.data.userProfile.gender === '' ||
        props.data.userProfile.birthday === '' ||
        props.data.userProfile.email === '' ||
        props.data.userProfile.email_confirmation === '' ||
        props.data.userProfile.school_id === '' ||
        props.data.userProfile.graduate_year === '' ||
        (props.data.userProfile.password === '' &&
          props.data.userProfile.socialplus_id === '') ||
        (props.data.userProfile.password_confirmation === '' &&
          props.data.userProfile.socialplus_id === '')
      ) {
        return true
      }

      if (props.data.userProfile.birthday) {
        const arr = props.data.userProfile.birthday.split('/')
        if (!arr[0] || !arr[1] || !arr[2]) return true
      }

      if (
        props.data.memberType === '2' &&
        (props.data.userProfile.licensing_year === '' ||
          props.data.userProfile.work_place === '')
      )
        return true

      console.log('入力validations', validations)
      const arr: Array<string> = Object.keys(validations)

      for (let i = 0; i < arr.length; i++) {
        if (validations[arr[i]].isError) return true
      }

      return false
    })

    const confirm = async () => {
      const fieldArr = Object.keys(validations)

      fieldArr.forEach((field: string) => {
        if (props.data.memberType === '1') {
          if (
            field === 'licensing_year' ||
            field === 'work_place' ||
            field === 'hoped_departments01' ||
            field === 'hoped_departments02' ||
            field === 'hoped_departments03'
          )
            return
        }

        let value = props.data.userProfile[field]
        let ruleArr: Array<string> = []

        if (
          field === 'email_confirmation' ||
          field === 'password_confirmation'
        ) {
          const rules = validations[field].rules
          for (let i = 0; i < rules.length; i++) {
            if (rules[i] === 'matchEmail') {
              ruleArr.push('matchEmail:' + props.data.userProfile['email'])
            } else if (
              rules[i] === 'matchPassword' &&
              props.data.userProfile.socialplus_id === ''
            ) {
              ruleArr.push(
                'matchPassword:' + props.data.userProfile['password']
              )
            } else {
              ruleArr.push(rules[i])
            }
          }
        } else {
          ruleArr = validations[field].rules
        }

        if (field === 'hoped_departments01')
          value = props.data.userProfile['hoped_departments'][0]
        if (field === 'hoped_departments02')
          value = props.data.userProfile['hoped_departments'][1]
        if (field === 'hoped_departments03')
          value = props.data.userProfile['hoped_departments'][2]

        const result = applyValidation(ruleArr, value)

        validations[field].isError = result.isError
        validations[field].errorMessage = result.message
      })

      console.log(fieldArr)
      const hasError = fieldArr.some((field: string) => {
        // NOTE: エラーになったフィールドだけconsole.errorに出力
        if (validations[field].isError) {
          console.error(field)
        }
        return validations[field].isError
      })

      if (hasError) {
        visibleErrorMessage.value = true
        smoothscroll.polyfill()
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        return
      }

      const csrf = ref(
        document
          .querySelector('meta[name="csrf-token"]')!
          .getAttribute('content')
      )

      store.commit('showLoading')

      try {
        const response = await axios.post('/api/checkRegister', {
          member_type: props.data.memberType,
          name_sei: props.data.userProfile.name_sei,
          name_mei: props.data.userProfile.name_sei,
          kana_sei: props.data.userProfile.kana_sei,
          kana_mei: props.data.userProfile.kana_mei,
          gender: props.data.userProfile.gender,
          birthday: props.data.userProfile.birthday,
          email: props.data.userProfile.email,
          email_confirmation: props.data.userProfile.email_confirmation,
          zip: props.data.userProfile.zip,
          prefecture: props.data.userProfile.prefecture,
          city: props.data.userProfile.city,
          town: props.data.userProfile.town,
          tel: props.data.userProfile.tel,
          zip_vacation: props.data.userProfile.zip_vacation,
          prefecture_vacation: props.data.userProfile.prefecture_vacation,
          city_vacation: props.data.userProfile.city_vacation,
          town_vacation: props.data.userProfile.town_vacation,
          school_id: props.data.userProfile.school_id,
          graduate_year: props.data.userProfile.graduate_year,
          licensing_year: props.data.userProfile.licensing_year,
          work_place: props.data.userProfile.work_place,
          hoped_departments: props.data.userProfile.hoped_departments,
          password: props.data.userProfile.password,
          // eslint-disable-next-line
          password_confirmation: props.data.userProfile.password_confirmation,
          socialplus_id: props.data.userProfile.socialplus_id,
          _token: csrf,
          doctor_regist_flg: props.data.doctor_regist_flg
        })
        store.commit('closeLoading')
        router.push({ path: '/register/confirm' })
      } catch (errors) {
        store.commit('closeLoading')
        if (errors.response.status === 429) {
          validations['email'].isError = true
          validations['email'].errorMessage = errors.response.data.errors[
            'email'
          ].join()
        } else if (errors.response.data) {
          const errorInfo = errors.response.data
          Object.keys(errorInfo).forEach((key) => {
            if (validations[key]) {
              validations[key].isError = true
              validations[key].errorMessage = errorInfo[key].join()
            }
          })
        }
        visibleErrorMessage.value = true
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        alert('入力内容に誤りがあるので確認してください')
      }
    }

    onMounted(async () => {
      context.emit('update-flow', 3)

      const params = new URLSearchParams(location.search)
      // tokenがある(Lineから戻ってきたとき)の処理
      const token = params.get('token')
      console.log(token)
      if (token) {
        formLineMessage.value = true
        try {
          const result = await axios.get(
            `/api/v1/socialplus_account?token=${token}`
          )

          console.info(result)
          Object.keys(result.data).forEach((key) => {
            changeMessage(key, result.data[key])
            if (key === 'prefecture' && result.data[key]) {
              if (prefectures[result.data[key]])
                prefectures[result.data[key]].selected = true
            }
          })
        } catch (error) {
          console.error(error)
        }

        // Cookie取得
        const cookie = document.cookie

        // 各値の処理
        const kewWordCookie: any = cookie
          .split('; ')
          .find((row: any) => row.startsWith('hopeKeywords'))
        const hopeKeywords = kewWordCookie.split('=')[1]
        context.emit('update-keywords-line', hopeKeywords.split(','))
        console.info('hopeKeywords', hopeKeywords)

        const prefecuteCookie: any = cookie
          .split('; ')
          .find((row: any) => row.startsWith('hopePrefectures'))
        const hopePrefectures = prefecuteCookie.split('=')[1]
        context.emit('update-prefectures-line', hopePrefectures.split(','))
        console.info('hopePrefectures', hopePrefectures)

        const memberTypeCookie: any = cookie
          .split('; ')
          .find((row: any) => row.startsWith('memberType'))
        const hopeMemberType = memberTypeCookie.split('=')[1]
        context.emit('update-member-type', hopeMemberType)
        console.info('hopeMemberType', hopeMemberType)

        const invitationCodeCookie: any = cookie
          .split('; ')
          .find((row: any) => row.startsWith('invitationCode'))
        const invitationCode = invitationCodeCookie.split('=')[1]
        context.emit('set-invitation-code', invitationCode)
        console.info('invitationCode', invitationCode)

        // Cookie削除
        document.cookie = 'hopeKeywords=; max-age=0'
        document.cookie = 'memberType=; max-age=0'
        document.cookie = 'hopePrefectures=; max-age=0'
        document.cookie = `invitationCode=; max-age=0`
      }
    })

    const goBack = () => {
      router.push('/register/select')
    }

    // TODO: 使ってない
    // const toLine = () => {
    //   document.cookie = `hopeKeywords=${props.data.hopeKeywords}; max-age=3600`
    //   document.cookie = `memberType=${props.data.memberType}; max-age=3600`
    //   document.cookie = `hopePrefectures=${props.data.hopePrefectures}; max-age=3600`
    //   document.cookie = `invitationCode=${props.data.invitationCode}; max-age=3600`
    //   location.href = `https://ca68f31f7a.auth.socialplus.jp/mynavi_resident/mynavi_resident_usr/line/authenticate?callback=${process.env.VUE_APP_URL}/register/profile&extended_items=real_name,gender,birthdate,address,email,phone`
    // }

    return {
      visibleErrorMessage,
      formLineMessage,
      genders,
      changeMessage,
      checkConfirmField,
      confirm,
      setYear,
      inputZip,
      changeVacationAddressState,
      prefectures,
      prefectures_vacation,
      universities,
      hoped_departments01,
      hoped_departments02,
      hoped_departments03,
      validations,
      isDisabledNextBtn,
      // toLine,
      goBack
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.profile-head {
  margin-bottom: 25px;
  @include mixins.media() {
    margin-bottom: 18px;
  }
}
.profile-note {
  margin-bottom: 30px;
  font-size: 1.2rem;
  line-height: 1.5;
  @include mixins.media() {
    margin-bottom: 37px;
  }
}
</style>
